import { withStyles } from "@material-ui/styles";
import LoadingIcon from "Components/LoadingIcon";
import NavigationSidepanel from "Components/NavigationSidepanel";
import ProfileDetailsForm from "Forms/ProfileDetailsForm";
import {
  GeneralSettingsForm,
  NotificationsForm,
  PasswordForm,
  ProfilePictureForm
} from "Forms/SettingsForm";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Route } from "react-router-dom";
import { compose } from "redux";
import AuthenticationActions, {
  AuthenticationSelectors
} from "Redux/AuthenticationRedux";
import ProfileActions, { ProfileSelectors } from "Redux/ProfileRedux";
import ProjectActions, { ProjectSelectors } from "Redux/ProjectRedux";
import { Fonts } from "Themes/Fonts";
import styles, {
  SettingsContainer,
  SettingsContentContainer,
  MainContainer
} from "./styles";
import Sidepanel from "Components/Sidepanel";
import navRoutes from "Navigation/NavRoutes";
import Button from "react-bootstrap/Button";
import styled from "styled-components";
import { mobileSize } from "Themes/Metrics";

const NavContainer = styled.div`
  @media ${mobileSize.large} {
    display: none;
  }
`;

const CustomiseButton = styled(Button)`
  display: none;
  @media ${mobileSize.large} {
    display: block;
    margin-bottom: 10px;
  }
`;

const initialState = {
  success: {
    updateProfileLinks: false,
    generalSettings: false,
    passwordReset: false
  },
  error: {
    updateProfileLinks: false,
    generalSettings: false,
    passwordReset: false
  },
  fetching: {
    profile: true,
    updateProfileLinks: false,
    generalSettings: false,
    passwordReset: false
  }
};

class SettingsScreen extends Component {
  state = {
    passwordResetError: null,
    passwordResetSuccess: false,
    generalSettingsFetching: false,
    passwordResetFetching: false,
    updateProfileLinkSuccess: true,
    ...initialState
  };

  async componentDidMount() {
    const { getProfile } = this.props;
    await getProfile();
    await this.props.getResources();
    await this.props.getProfileLinks(this.props.user.id);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location !== this.props.location) {
      this.setState({
        ...initialState
      });
    }
  }

  _handleSuccessAlert = () => {
    this.setState({
      showSuccessSweetAlert: false
    });
  };

  handleUpdateSuccess = () => {
    this.setState(prevState => ({
      fetching: {
        ...prevState.fetching,
        generalSettings: false
      },
      error: {
        ...prevState.error,
        generalSettings: false
      },
      success: {
        ...prevState.success,
        generalSettings: true
      }
    }));
  };

  handleUpdateFailure = error => {
    this.setState(prevState => ({
      fetching: {
        ...prevState.fetching,
        generalSettings: false
      },
      error: {
        ...prevState.error,
        generalSettings: true
      },
      success: {
        ...prevState.success,
        generalSettings: false
      }
    }));
  };

  _handleSubmit = async values => {
    const {
      user: { id, email, firstName, lastName }
    } = this.props;

    this.setState(prevState => ({
      fetching: {
        ...prevState.fetching,
        generalSettings: true
      }
    }));

    const resolve = {
      onSuccess: () => this.handleUpdateSuccess(),
      onFailure: error => this.handleUpdateFailure(error)
    };

    const data = {
      id,
      email: values.email ? values.email : email,
      firstName: values.firstName ? values.firstName : firstName,
      lastName: values.lastName ? values.lastName : lastName
    };

    await this.props.updateUserDetails(data, resolve);
  };

  handlePasswordSubmit = async values => {
    this.setState(prevState => ({
      fetching: { ...prevState.fetching, passwordReset: true }
    }));
    const data = {
      values: values,
      submissionError: error =>
        this.setState(prevState => ({
          error: { ...prevState.error, passwordReset: error.message },
          success: { ...prevState.success, passwordReset: false }
        })),
      submissionSuccess: () =>
        this.setState(prevState => ({
          error: { ...prevState.error, passwordReset: false },
          success: { ...prevState.success, passwordReset: true }
        }))
    };
    this.setState(prevState => ({
      fetching: { ...prevState.fetching, passwordReset: false }
    }));
    await this.props.passwordReset(data);
  };

  handleProfileDetailsSubmit = async data => {
    const { updateProfileLinks } = this.props;
    this.setState(prevState => ({
      fetching: { ...prevState.fetching, updateProfileLinks: true }
    }));

    const resolve = {
      onSuccess: () =>
        this.setState(prevState => ({
          success: {
            ...prevState.success,
            updateProfileLinks: true
          },
          fetching: {
            ...prevState.fetching,
            updateProfileLinks: false
          }
        })),
      onFailure: () =>
        this.setState(prevState => ({
          error: {
            ...prevState.error,
            updateProfileLinks: true
          },
          fetching: {
            ...prevState.fetching,
            updateProfileLinks: false
          }
        }))
    };

    await updateProfileLinks(data, resolve);
  };

  _handleSubmitAvatar = async croppedImage => {
    const { updateAvatar } = this.props;
    await updateAvatar(croppedImage);
  };

  renderNavigationSidepanel = () => {
    const { settings, general, links, avatar, password } = navRoutes;
    return (
      <NavigationSidepanel
        titles={["General", "Profile Links", "Profile Picture", "Password"]}
        rootPath={settings}
        links={[general, links, avatar, password]}
      />
    );
  };

  toggleSidepanel = () => {
    this.setState({
      openSidepanel: !this.state.openSidepanel
    });
  };

  render() {
    const {
      history,
      classes,
      user,
      passwordReset,
      profile,
      profileLinks
    } = this.props;
    const { fetching, success, error, openSidepanel } = this.state;

    const { settings, general, links, avatar, password } = navRoutes;

    if (!profile) {
      return (
        <div
          style={{
            marginTop: "20%",
            justifyContent: "center",
            display: "flex"
          }}
        >
          <LoadingIcon />
        </div>
      );
    }

    return (
      <MainContainer>
        <h1 style={Fonts.headerFont}>Settings</h1>
        <SettingsContainer className={classes.settingsContainer}>
          <div className={classes.navigationSidepanel}>
            <CustomiseButton onClick={this.toggleSidepanel}>
              Customise
            </CustomiseButton>
            <Sidepanel open={openSidepanel} onHide={this.toggleSidepanel}>
              {this.renderNavigationSidepanel()}
            </Sidepanel>
            <NavContainer>{this.renderNavigationSidepanel()}</NavContainer>
          </div>
          <SettingsContentContainer>
            <Route
              path={`${settings}${general}`}
              component={() => (
                <GeneralSettingsForm
                  handleSubmit={this._handleSubmit}
                  email={user.email}
                  firstName={user.firstName}
                  generalSettingsError={error.generalSettings}
                  generalSettingsSuccess={success.generalSettings}
                  fetching={fetching.generalSettings}
                />
              )}
            />
            <Route
              path={`${settings}${links}`}
              component={() => (
                <ProfileDetailsForm
                  handleSubmit={this.handleProfileDetailsSubmit}
                  resources={this.props.resources}
                  profileLinks={profileLinks}
                  customIcon={user.avatar}
                  fetching={fetching.updateProfileLinks}
                  success={success.updateProfileLinks}
                  error={error.updateProfileLinks}
                />
              )}
            />
            <Route
              path={`${settings}${avatar}`}
              component={() => (
                <ProfilePictureForm
                  avatar={user.avatar}
                  history={history}
                  handleSubmit={this._handleSubmitAvatar}
                />
              )}
            />
            <Route
              path={`${settings}${password}`}
              component={() => (
                <PasswordForm
                  handleSubmit={this.handlePasswordSubmit}
                  passwordReset={passwordReset}
                  passwordResetError={error.passwordReset}
                  passwordResetSuccess={success.passwordReset}
                  fetching={fetching.passwordReset}
                />
              )}
            />
            <Route
              path="/Settings/Notifications"
              component={() => <NotificationsForm />}
            />
          </SettingsContentContainer>
        </SettingsContainer>
      </MainContainer>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: AuthenticationSelectors.getUserDetails(state),
    profile: ProfileSelectors.getProfile(state),
    authFetching: AuthenticationSelectors.getFetching(state),
    profileFetching: ProfileSelectors.getFetching(state),
    passwordReset: AuthenticationSelectors.getPasswordReset(state),
    resources: ProjectSelectors.getResources(state),
    profileLinks: ProfileSelectors.getProfileLinks(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getProfile: () => dispatch(ProfileActions.profileRequest()),
    profileUpdate: (data, resolve) =>
      dispatch(ProfileActions.profileUpdateRequest(data, resolve)),
    passwordReset: data =>
      dispatch(AuthenticationActions.passwordResetRequest(data)),
    updateUserDetails: (data, resolve) =>
      dispatch(AuthenticationActions.updateUserDetailsRequest(data, resolve)),
    getResources: () => dispatch(ProjectActions.getResourcesRequest()),
    getProfileLinks: data =>
      dispatch(ProfileActions.getProfileLinksRequest(data)),
    updateAvatar: data => dispatch(ProfileActions.updateAvatarRequest(data)),
    updateProfileLinks: (data, resolve) => {
      dispatch(ProfileActions.updateProfileLinksRequest(data, resolve));
    }
  };
};

const withRedux = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default compose(
  withStyles(styles),
  withRedux
)(SettingsScreen);
